__turbopack_context__.v({
  "clip": "vcGALW_clip",
  "clipCompact": "vcGALW_clipCompact",
  "clipFixedHeight": "vcGALW_clipFixedHeight",
  "clipMatchMedia": "vcGALW_clipMatchMedia",
  "divider": "vcGALW_divider",
  "featureBody": "vcGALW_featureBody",
  "featureCopy": "vcGALW_featureCopy",
  "featureIcon": "vcGALW_featureIcon",
  "featureItem": "vcGALW_featureItem",
  "featureList": "vcGALW_featureList",
  "featureTitle": "vcGALW_featureTitle",
  "featuresEyebrow": "vcGALW_featuresEyebrow",
  "featuresLayout": "vcGALW_featuresLayout",
  "introBody": "vcGALW_introBody",
  "metricAlignTop": "vcGALW_metricAlignTop",
  "metricCaption": "vcGALW_metricCaption",
  "metricDecor": "vcGALW_metricDecor",
  "metricEyebrow": "vcGALW_metricEyebrow",
  "metricLayout": "vcGALW_metricLayout",
  "metricValue": "vcGALW_metricValue",
  "metricValueCompact": "vcGALW_metricValueCompact",
  "metricValueRow": "vcGALW_metricValueRow",
  "panel": "vcGALW_panel",
  "panelDark": "vcGALW_panelDark",
  "panelLight": "vcGALW_panelLight",
});
